import { render, staticRenderFns } from "./cooperation_cert_list.vue?vue&type=template&id=b0cd7c62&scoped=true&"
import script from "./cooperation_cert_list.vue?vue&type=script&lang=js&"
export * from "./cooperation_cert_list.vue?vue&type=script&lang=js&"
import style0 from "./cooperation_cert_list.vue?vue&type=style&index=0&id=b0cd7c62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cd7c62",
  null
  
)

export default component.exports